/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  OrganizationMemberRead,
  UserClassGroupCreate,
  UserClassGroupListItem,
  UserClassGroupRead,
  UserClassGroupUpdate,
  UserRead,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    OrganizationMemberReadFromJSON,
    OrganizationMemberReadToJSON,
    UserClassGroupCreateFromJSON,
    UserClassGroupCreateToJSON,
    UserClassGroupListItemFromJSON,
    UserClassGroupListItemToJSON,
    UserClassGroupReadFromJSON,
    UserClassGroupReadToJSON,
    UserClassGroupUpdateFromJSON,
    UserClassGroupUpdateToJSON,
    UserReadFromJSON,
    UserReadToJSON,
} from '../models/index';

export interface AddUserToClassRequest {
    classId: string;
    userId: string;
    xOrganizationID?: string | null;
}

export interface CreateClassRequest {
    userClassGroupCreate: UserClassGroupCreate;
    xOrganizationID?: string | null;
}

export interface DeleteClassRequest {
    classId: string;
    xOrganizationID?: string | null;
}

export interface GetAllClassesRequest {
    includeDeleted?: boolean;
    xOrganizationID?: string | null;
}

export interface GetClassByIdRequest {
    classId: string;
    xOrganizationID?: string | null;
}

export interface GetClassMemberSummariesRequest {
    classId: string;
    xOrganizationID?: string | null;
}

export interface GetClassMembersRequest {
    classId: string;
    xOrganizationID?: string | null;
}

export interface GetUserClassesRequest {
    userId: string;
    xOrganizationID?: string | null;
}

export interface RemoveUserFromClassRequest {
    classId: string;
    userId: string;
    xOrganizationID?: string | null;
}

export interface UpdateClassRequest {
    classId: string;
    userClassGroupUpdate: UserClassGroupUpdate;
    xOrganizationID?: string | null;
}

/**
 * 
 */
export class ClassesApi extends runtime.BaseAPI {

    /**
     * Add a user to a class group. Admin only.  Args:     class_id: ID of the class     user_id: ID of the user to add     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Returns:     Success message  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 404 if class or user not found     HTTPException: 400 if user already in class
     * Add User To Class
     */
    async addUserToClassRaw(requestParameters: AddUserToClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['classId'] == null) {
            throw new runtime.RequiredError(
                'classId',
                'Required parameter "classId" was null or undefined when calling addUserToClass().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling addUserToClass().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/classes/{class_id}/members/{user_id}`.replace(`{${"class_id"}}`, encodeURIComponent(String(requestParameters['classId']))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Add a user to a class group. Admin only.  Args:     class_id: ID of the class     user_id: ID of the user to add     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Returns:     Success message  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 404 if class or user not found     HTTPException: 400 if user already in class
     * Add User To Class
     */
    async addUserToClass(requestParameters: AddUserToClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.addUserToClassRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new user class group in the organization of the request header. Admin only.  Args:     class_data: Class information     organization_id: Current organization context (injected from header)     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Returns:     The created class  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 400 if class with same name already exists
     * Create Class
     */
    async createClassRaw(requestParameters: CreateClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserClassGroupRead>> {
        if (requestParameters['userClassGroupCreate'] == null) {
            throw new runtime.RequiredError(
                'userClassGroupCreate',
                'Required parameter "userClassGroupCreate" was null or undefined when calling createClass().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/classes/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserClassGroupCreateToJSON(requestParameters['userClassGroupCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserClassGroupReadFromJSON(jsonValue));
    }

    /**
     * Create a new user class group in the organization of the request header. Admin only.  Args:     class_data: Class information     organization_id: Current organization context (injected from header)     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Returns:     The created class  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 400 if class with same name already exists
     * Create Class
     */
    async createClass(requestParameters: CreateClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserClassGroupRead> {
        const response = await this.createClassRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft delete a user class group. Admin only.  Args:     class_id: ID of the class to delete     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Returns:     The deleted class  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 404 if class not found     HTTPException: 400 if class already deleted
     * Delete Class
     */
    async deleteClassRaw(requestParameters: DeleteClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserClassGroupRead>> {
        if (requestParameters['classId'] == null) {
            throw new runtime.RequiredError(
                'classId',
                'Required parameter "classId" was null or undefined when calling deleteClass().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/classes/{class_id}`.replace(`{${"class_id"}}`, encodeURIComponent(String(requestParameters['classId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserClassGroupReadFromJSON(jsonValue));
    }

    /**
     * Soft delete a user class group. Admin only.  Args:     class_id: ID of the class to delete     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Returns:     The deleted class  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 404 if class not found     HTTPException: 400 if class already deleted
     * Delete Class
     */
    async deleteClass(requestParameters: DeleteClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserClassGroupRead> {
        const response = await this.deleteClassRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all user class groups for the organization. Staff of the organization.  `include_deleted` only applies to administrators; for other staff it is ignored.  Args:     organization_id: Current organization context (injected from header)     current_user: Current authenticated user (injected)     session: Database session (injected)     include_deleted: Whether to include soft-deleted classes  Returns:     List of all classes in the organization, each with `member_count` (its active members)  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization
     * Get All Classes
     */
    async getAllClassesRaw(requestParameters: GetAllClassesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserClassGroupListItem>>> {
        const queryParameters: any = {};

        if (requestParameters['includeDeleted'] != null) {
            queryParameters['include_deleted'] = requestParameters['includeDeleted'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/classes/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserClassGroupListItemFromJSON));
    }

    /**
     * Get all user class groups for the organization. Staff of the organization.  `include_deleted` only applies to administrators; for other staff it is ignored.  Args:     organization_id: Current organization context (injected from header)     current_user: Current authenticated user (injected)     session: Database session (injected)     include_deleted: Whether to include soft-deleted classes  Returns:     List of all classes in the organization, each with `member_count` (its active members)  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization
     * Get All Classes
     */
    async getAllClasses(requestParameters: GetAllClassesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserClassGroupListItem>> {
        const response = await this.getAllClassesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific class of the organization by ID. Staff of the organization.  Args:     class_id: ID of the class     organization_id: Current organization context (injected from header)     current_user: Current authenticated user (injected)     session: Database session (injected)  Returns:     The requested class  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization     HTTPException: 404 if the class is not found in the organization
     * Get Class By Id
     */
    async getClassByIdRaw(requestParameters: GetClassByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserClassGroupRead>> {
        if (requestParameters['classId'] == null) {
            throw new runtime.RequiredError(
                'classId',
                'Required parameter "classId" was null or undefined when calling getClassById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/classes/{class_id}`.replace(`{${"class_id"}}`, encodeURIComponent(String(requestParameters['classId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserClassGroupReadFromJSON(jsonValue));
    }

    /**
     * Get a specific class of the organization by ID. Staff of the organization.  Args:     class_id: ID of the class     organization_id: Current organization context (injected from header)     current_user: Current authenticated user (injected)     session: Database session (injected)  Returns:     The requested class  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization     HTTPException: 404 if the class is not found in the organization
     * Get Class By Id
     */
    async getClassById(requestParameters: GetClassByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserClassGroupRead> {
        const response = await this.getClassByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the active members of a class without contact data. Staff of the organization.  Args:     class_id: ID of the class     organization_id: Current organization context (injected from header)     current_user: Current authenticated user (injected)     session: Database session (injected)  Returns:     Members as id, username, names and role ids in the organization  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization     HTTPException: 404 if the class is not found in the organization
     * Get Class Member Summaries
     */
    async getClassMemberSummariesRaw(requestParameters: GetClassMemberSummariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrganizationMemberRead>>> {
        if (requestParameters['classId'] == null) {
            throw new runtime.RequiredError(
                'classId',
                'Required parameter "classId" was null or undefined when calling getClassMemberSummaries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/classes/{class_id}/member-summaries`.replace(`{${"class_id"}}`, encodeURIComponent(String(requestParameters['classId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganizationMemberReadFromJSON));
    }

    /**
     * Get the active members of a class without contact data. Staff of the organization.  Args:     class_id: ID of the class     organization_id: Current organization context (injected from header)     current_user: Current authenticated user (injected)     session: Database session (injected)  Returns:     Members as id, username, names and role ids in the organization  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization     HTTPException: 404 if the class is not found in the organization
     * Get Class Member Summaries
     */
    async getClassMemberSummaries(requestParameters: GetClassMemberSummariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrganizationMemberRead>> {
        const response = await this.getClassMemberSummariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all users in a class of the organization with full profiles. Admin only.  Staff who are not administrators use `get_class_member_summaries`.  Args:     class_id: ID of the class     organization_id: Current organization context (injected from header)     current_user: Current authenticated user (injected)     session: Database session (injected)  Returns:     List of users in the class, as public user profiles (never credentials)  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 404 if the class is not found in the organization
     * Get Class Members
     */
    async getClassMembersRaw(requestParameters: GetClassMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserRead>>> {
        if (requestParameters['classId'] == null) {
            throw new runtime.RequiredError(
                'classId',
                'Required parameter "classId" was null or undefined when calling getClassMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/classes/{class_id}/members`.replace(`{${"class_id"}}`, encodeURIComponent(String(requestParameters['classId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserReadFromJSON));
    }

    /**
     * Get all users in a class of the organization with full profiles. Admin only.  Staff who are not administrators use `get_class_member_summaries`.  Args:     class_id: ID of the class     organization_id: Current organization context (injected from header)     current_user: Current authenticated user (injected)     session: Database session (injected)  Returns:     List of users in the class, as public user profiles (never credentials)  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 404 if the class is not found in the organization
     * Get Class Members
     */
    async getClassMembers(requestParameters: GetClassMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserRead>> {
        const response = await this.getClassMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all classes a user belongs to. Admin only.  Args:     user_id: ID of the user     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Returns:     List of classes the user belongs to  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator
     * Get User Classes
     */
    async getUserClassesRaw(requestParameters: GetUserClassesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserClassGroupRead>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserClasses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/classes/users/{user_id}/classes`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserClassGroupReadFromJSON));
    }

    /**
     * Get all classes a user belongs to. Admin only.  Args:     user_id: ID of the user     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Returns:     List of classes the user belongs to  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator
     * Get User Classes
     */
    async getUserClasses(requestParameters: GetUserClassesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserClassGroupRead>> {
        const response = await this.getUserClassesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a user from a class group. Admin only.  Args:     class_id: ID of the class     user_id: ID of the user to remove     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 404 if class, user, or membership not found
     * Remove User From Class
     */
    async removeUserFromClassRaw(requestParameters: RemoveUserFromClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['classId'] == null) {
            throw new runtime.RequiredError(
                'classId',
                'Required parameter "classId" was null or undefined when calling removeUserFromClass().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling removeUserFromClass().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/classes/{class_id}/members/{user_id}`.replace(`{${"class_id"}}`, encodeURIComponent(String(requestParameters['classId']))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a user from a class group. Admin only.  Args:     class_id: ID of the class     user_id: ID of the user to remove     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 404 if class, user, or membership not found
     * Remove User From Class
     */
    async removeUserFromClass(requestParameters: RemoveUserFromClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeUserFromClassRaw(requestParameters, initOverrides);
    }

    /**
     * Update a user class group. Admin only.  Args:     class_id: ID of the class to update     class_data: Updated class information     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Returns:     The updated class  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 404 if class not found     HTTPException: 400 if name already exists
     * Update Class
     */
    async updateClassRaw(requestParameters: UpdateClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserClassGroupRead>> {
        if (requestParameters['classId'] == null) {
            throw new runtime.RequiredError(
                'classId',
                'Required parameter "classId" was null or undefined when calling updateClass().'
            );
        }

        if (requestParameters['userClassGroupUpdate'] == null) {
            throw new runtime.RequiredError(
                'userClassGroupUpdate',
                'Required parameter "userClassGroupUpdate" was null or undefined when calling updateClass().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/classes/{class_id}`.replace(`{${"class_id"}}`, encodeURIComponent(String(requestParameters['classId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserClassGroupUpdateToJSON(requestParameters['userClassGroupUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserClassGroupReadFromJSON(jsonValue));
    }

    /**
     * Update a user class group. Admin only.  Args:     class_id: ID of the class to update     class_data: Updated class information     current_user: Current authenticated admin user (injected)     session: Database session (injected)  Returns:     The updated class  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not an administrator     HTTPException: 404 if class not found     HTTPException: 400 if name already exists
     * Update Class
     */
    async updateClass(requestParameters: UpdateClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserClassGroupRead> {
        const response = await this.updateClassRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
